var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisabledPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.278,
    height: 34.539,
    viewBox: "0 0 26.278 34.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#195cff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-61.233)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.233 9.015)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.443,156.361l-2.252-9.76a2.249,2.249,0,0,0-2.185-1.706H78.629a9.4,9.4,0,0,0-2.381-2.625v-6.385a2.267,2.267,0,0,0-3.26-2.015l-4.5,2.252a2.233,2.233,0,0,0-1.237,2.015v2.881c-.014,0-.028.006-.042.012A9.385,9.385,0,1,0,79.986,149.4h1.261l1.826,8.055a2.253,2.253,0,1,0,4.37-1.093Zm-16.826.547A7.125,7.125,0,0,1,67.246,143.5V146.4a2.249,2.249,0,1,0,4.5,0V142.71a1.121,1.121,0,0,0,.172.05,7.134,7.134,0,0,1-1.3,14.148Z",
    transform: "translate(-61.233 -133.638)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.993)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M209.3,0a3.379,3.379,0,1,0,3.379,3.379A3.382,3.382,0,0,0,209.3,0Z",
    transform: "translate(-205.918)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledPerson);
export default __webpack_public_path__ + "static/media/disabled-person.aef8db8b8840bcc8f20f147420f9aa6b.svg";
export { ForwardRef as ReactComponent };